import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=36557f4a&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=36557f4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36557f4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36557f4a')) {
      api.createRecord('36557f4a', component.options)
    } else {
      api.reload('36557f4a', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=36557f4a&scoped=true&", function () {
      api.rerender('36557f4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FyrwVAet4nt3/JS/comp/DocBox.vue"
export default component.exports